import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Select } from '@rmwc/select';
import { updateField } from '../../actions/actionCreators';
import errorMessage from '../../utils/errorMessage';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { FormField } from '@rmwc/formfield';
import { validators } from '../../utils/validators';

interface DropdownFieldProps {
  name: string;
  form: string;
  required?: boolean;
  className?: string;
  type?: string;
  fullWidth?: boolean;
  hidden?: boolean;
  defaultValue?: string;
  onChange?: (string) => void;
  label?: string;
  options: { value: string; label: string }[];
}

const DropdownField: React.FC<DropdownFieldProps> = ({
  name,
  form,
  required,
  className,
  type,
  fullWidth,
  hidden,
  defaultValue,
  options,
  onChange,
  label,
}) => {
  const dispatch = useAppDispatch();
  const value = useAppSelector(
    (state) => state.forms[form]?.[name]?.value || ''
  );

  const [error, setError] = useState(null);

  const validate = () => {
    const errorMessages = errorMessage(
      { name, required },
      validators.required(value)
    );

    setError(errorMessages || null);
    return !errorMessages;
  };

  useEffect(() => {
    if (error) {
      validate();
    }
  }, [value]);

  const handleChange = (e) => {
    dispatch(updateField(form, name, e.target.value));

    if (onChange) {
      onChange(e.target.value);
    }
  };

  const handleBlur = () => {
    if (error) {
      validate();
    }
  };

  const fieldClass = classNames({
    form__fieldholder: true,
    'form__fieldholder--error': error,
    'form__fieldholder--hasValue': value,
    'form__fieldholder--fullWidth': fullWidth,
    'form__fieldholder--hidden': hidden,
  });

  return (
    <FormField className={fieldClass}>
      <Select
        type={type}
        name={name}
        label={label}
        placeholder=""
        id={name}
        value={value || defaultValue}
        onBlur={handleBlur}
        onChange={handleChange}
        required={required}
        className={className}
        options={options}
        enhanced={{
          renderToPortal: true,
          anchorCorner: 'topLeft',
        }}
      />
    </FormField>
  );
};

export default DropdownField;
